import { CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import { DownloadIcon } from '@root/core/components/Icon';
import { ViewerBox } from '@root/modules/Busk/Forwarding-Content/components/ViewerBox';
import { Editor } from '@toast-ui/react-editor';
import { Editor as EditorType } from '@toast-ui/editor';
import { Button, Col, Modal, Row, Typography } from 'antd';
import confirm from 'antd/lib/modal/confirm';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import forwardingService from '../../services';

const ForwarederMsg = () => {
  const { id } = useParams<{ id: string }>();
  const [fileList, setFileList] = useState<any[]>([]);
  const [data, setData] = useState<any>(null);
  console.log(data?.status);
  const handleUploadChange = (e: any) => {
    if (e.target.files[0]) {
      setFileList([...fileList, e.target.files[0]]);
    }
  };

  const handleFileDelete = (fileName: string) => {
    setFileList(
      fileList.filter((file) => {
        if ('name' in file && !('uploadFile' in file)) {
          return file.name !== fileName;
        }
        return file.uploadFile.fileName !== fileName;
      })
    );
  };

  const [mode, setMode] = useState<'edit' | 'create'>('create');

  const [msgId, setMsgId] = useState(0);
  const [content, setContent] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderProgressBtn = () => {
    switch (data?.status) {
      case 'Inprogress':
        return (
          <Button
            onClick={onAccept}
            className="btn-style"
            style={{ backgroundColor: '#629C53', color: 'white' }}
          >
            Proposal to state shipping
          </Button>
        );

      case 'ShippingConfirm':
        return (
          <Button
            onClick={onFinish}
            className="btn-style"
            style={{ backgroundColor: '#629C53', color: 'white' }}
          >
            Shipping Arrival
          </Button>
        );

      default:
        return null;
    }
  };
  const renderCancelBtn = () => {
    switch (data?.cancelStatus) {
      case 'SellerCancel':
        return (
          <Button
            onClick={async () => {
              await forwardingService.updateStatus(id, {
                cancelStatus: 'None'
              });
              fetchData();
            }}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            Request to end the conversation accepted
          </Button>
        );
      case 'ForwardingCancel':
        return (
          <Button
            onClick={async () => {
              await forwardingService.updateStatus(id, {
                cancelStatus: 'None'
              });
              fetchData();
            }}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            Cancel conversation end requests
          </Button>
        );
      case 'None':
        return (
          <Button
            onClick={onClose}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            End the conversation
          </Button>
        );
      default:
        return null;
    }
  };

  const onClose = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: 'Would you like to end the conversation?',
      content: (
        <>
          <p>
            Clicking 'Confirm' will send a request for approval to the seller to
            end the conversation.
          </p>
          <p>
            Once the conversation ends, the conversation data will be deleted
            after 60 days.
          </p>
        </>
      ),
      icon: false,
      centered: true,
      okText: 'confirm',
      cancelText: 'cancellation',
      async onOk() {
        await forwardingService.updateStatus(id, {
          cancelStatus: 'ForwardingCancel'
        });
        fetchData();
      },
      onCancel() {}
    });
  };

  const onCancel = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '진행 완료를 철회하시겠습니까?',
      content: ` confirm을 클릭하면 선적 도착으로 상태가 변경됩니다.`,
      icon: false,
      centered: true,
      okText: 'confirm',
      cancelText: 'cancellation',
      async onOk() {
        await forwardingService.updateStatus(id, {
          status: 'ShippingArrival'
        });
        fetchData();
      },
      onCancel() {}
    });
  };

  const onAccept = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: 'Would you like to offer to start shipping?',
      content: (
        <p>
          After clicking Confirm, an offer will be sent to the seller to begin
          shipping.
        </p>
      ),
      icon: false,
      centered: true,
      okText: 'confirm',
      cancelText: 'cancellation',
      async onOk() {
        await forwardingService.updateStatus(id, {
          status: 'ShippingProposal'
        });
        fetchData();
      },
      onCancel() {}
    });
  };
  const onFinish = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: 'Would you like to process the shipment arrival?',
      content: (
        <p>
          When you click Confirm, the seller will be notified of the arrival of
          the shipment.
        </p>
      ),
      icon: false,
      centered: true,
      okText: 'confirm',
      cancelText: 'cancellation',
      async onOk() {
        await forwardingService.updateStatus(id, {
          status: 'ShippingArrival'
        });
        fetchData();
      },
      onCancel() {}
    });
  };

  const fetchData = async () => {
    const res = await forwardingService.getInboundDetail(id);
    setData(res);
    console.log(res);
  };

  const createMessage = async () => {
    let filesId = [];

    // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
    const newFiles = fileList.filter(
      (file) => 'name' in file && !('uploadFile' in file)
    ) as File[];
    if (newFiles.length > 0) {
      const files = await forwardingService.uploadFile(newFiles);
      filesId = files?.data?.attachments?.map((file: any) => file.id);
    }

    // 기존 파일들의 ID 추가
    const existingFileIds = fileList
      .filter((file) => 'uploadFile' in file)
      .map((file) => file.uploadFile.id);

    filesId = [...filesId, ...existingFileIds];

    const res = await forwardingService.createMessage({
      postId: Number(id),
      content: content,
      attachment: filesId
    });
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const editorRef = useRef<any>(null);

  useEffect(() => {
    if (mode === 'edit' && data?.postDialogs[msgId]?.content) {
      setContent(data.postDialogs[msgId].content);
      editorRef.current
        ?.getInstance()
        .setMarkdown(data.postDialogs[msgId].content);
    } else if (mode === 'create') {
      setContent('');
      editorRef.current?.getInstance().setMarkdown('');
    }
  }, [mode, data, msgId]);

  const handleDownload = (url: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const updateMessage = async () => {
    let filesId = [];

    // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
    const newFiles = fileList.filter(
      (file) => 'name' in file && !('uploadFile' in file)
    ) as File[];
    if (newFiles.length > 0) {
      const files = await forwardingService.uploadFile(newFiles);
      filesId = files?.data?.attachments?.map((file: any) => file.id);
    }

    // 기존 파일들의 ID 추가
    const existingFileIds = fileList
      .filter((file) => 'uploadFile' in file)
      .map((file) => file.uploadFile.id);

    filesId = [...filesId, ...existingFileIds];
    const res = await forwardingService.updateMessage(msgId, {
      content: content,
      attachment: filesId
    });
    fetchData();
  };

  const onUploadImage = async (blob: File, callback: any) => {
    const url = await forwardingService.uploadFile([blob]);
    callback(url.data.attachments[0].url, '');
    return false;
  };

  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: 63,
          backgroundColor: '#f0f2f5',
          zIndex: 100
        }}
      >
        <div
          style={{
            padding: '1rem',
            backgroundColor: 'white',
            marginBottom: 13
          }}
        >
          <Row>
            <Col flex={10} style={{ paddingTop: '5px' }}>
              <span>{data?.seller?.companyName}</span>
              <span style={{ color: '#777777', fontSize: 10, marginLeft: 8 }}>
                {data?.seller?.email}
              </span>
            </Col>
            <Col flex={0.1}>
              <Button
                disabled={data?.cancelStatus === 'CancelComplete'}
                onClick={() => {
                  setMode('create');
                  setIsModalOpen(true);
                }}
                style={{ borderRadius: 8 }}
              >
                Send message
              </Button>
            </Col>
          </Row>
        </div>
        {data?.cancelStatus === 'CancelComplete' && (
          <p
            style={{
              color: '#D98282',
              marginTop: 8,
              fontSize: 12,
              fontWeight: 500
            }}
          >
            The conversation has ended.
          </p>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 36
          }}
        >
          <div style={{ display: 'flex', gap: 8 }}>
            {renderCancelBtn()}
            {data?.cancelStatus !== 'CancelComplete' && renderProgressBtn()}
          </div>

          <Typography.Text
            style={{
              background: 'rgb(43, 44, 81)',
              padding: '0.25rem 2rem',
              borderRadius: '1rem',
              color: 'white',
              marginLeft: '10px'
            }}
          >
            {data?.status}
          </Typography.Text>
        </div>
      </div>
      {data?.postDialogs?.map((item: any, key: number) => (
        <div key={key} style={{ marginTop: 20 }}>
          <ViewerBox
            imgSrc={`/images/${
              item.writerType === 'Seller'
                ? 'S'
                : item.writerType === 'Busk'
                ? 'B'
                : 'F'
            }.png`}
            initialValue={item.content}
            name={
              item.writerType === 'Seller'
                ? data?.seller?.companyName
                : item.writerName
            }
            date={new Date(item.created_at)}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 8
            }}
          >
            <div style={{ display: 'flex', gap: 12 }}>
              {item.dialogFiles.map((file: any, key: number) => (
                <Button
                  key={key}
                  onClick={() =>
                    handleDownload(
                      file.uploadFile.url,
                      file.uploadFile.fileName
                    )
                  }
                  style={{
                    padding: '0px 12px',
                    height: 30,
                    fontSize: 12,
                    borderRadius: 8,
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center'
                  }}
                >
                  <span>{file.uploadFile.fileName}</span>
                  <DownloadIcon />
                </Button>
              ))}
            </div>
            {item.canEdit && (
              <Button
                disabled={data?.cancelStatus === 'CancelComplete'}
                onClick={() => {
                  setMsgId(item.id);
                  setIsModalOpen(true);
                  setContent(item.content);
                  setMode('edit');
                  setFileList(item.dialogFiles);
                }}
                style={{
                  width: 80,
                  fontSize: 12,
                  fontWeight: 500,
                  borderRadius: 8
                }}
              >
                Edit
              </Button>
            )}
          </div>
        </div>
      ))}

      <Modal
        width={'auto'}
        closeIcon={<CloseOutlined />}
        onCancel={() => setIsModalOpen(false)}
        title="Write a message"
        className="forwarding-modal"
        visible={isModalOpen}
        footer={[
          <button
            disabled={!!!content}
            onClick={() => {
              mode === 'create' ? createMessage() : updateMessage();
              setIsModalOpen(false);
            }}
            className="forwarding-btn"
          >
            {mode === 'create' ? 'Send message' : 'Edit'}
          </button>
        ]}
        centered
      >
        <Editor
          initialEditType="wysiwyg"
          hooks={{
            addImageBlobHook: (blob, callback) =>
              onUploadImage(blob as File, callback)
          }}
          onChange={() => {
            const markdown =
              editorRef.current?.getInstance()?.getMarkdown() || '';
            setContent(markdown);
          }}
          hideModeSwitch={true}
          ref={editorRef}
        />
        <div className="file-wrap">
          <label htmlFor="file" className="file-btn">
            <span>File</span>
            <PaperClipOutlined width={16} height={16} />
          </label>
          <input
            onChange={handleUploadChange}
            type="file"
            id="file"
            style={{ display: 'none' }}
          />
          <div style={{ display: 'flex', gap: 12, overflowX: 'auto' }}>
            {fileList.map((file, index) => (
              <Button className="file-name" key={index}>
                <span>
                  {'name' in file && !('uploadFile' in file)
                    ? file.name
                    : file.uploadFile.fileName}
                </span>
                <CloseOutlined
                  onClick={() =>
                    handleFileDelete(
                      'name' in file && !('uploadFile' in file)
                        ? file.name
                        : file.uploadFile.fileName
                    )
                  }
                />
              </Button>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ForwarederMsg;
